import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import { camelize } from '@ember/string';
import type FeatureFlagsService from 'garaje/services/feature-flags';

export interface FeatureEnabledSignature {
  Args: {
    Positional: [featureName: string];
  };
  Return: boolean;
}

/**
 * This FeatureEnabled helper determines if a feature is on or off
 * Handy for template only components when you don't want to create a component.js when all you need is the featureFlags service :)
 *
 * Example usage:
 * <input readonly={{feature-enabled "your-feature"}} ... >
 */
export default class FeatureEnabled extends Helper<FeatureEnabledSignature> {
  @service declare featureFlags: FeatureFlagsService;

  compute([feature]: FeatureEnabledSignature['Args']['Positional']): FeatureEnabledSignature['Return'] {
    return this.featureFlags.isEnabled(camelize(feature));
  }
}
